module.exports = __webpack_public_path__ + "static/media/se_child_skrivhastighet_video.dc8c648d.mp4";